import React, { FC, useEffect, useRef, useState } from 'react';
import { addComma } from 'src/utils/common';
import { preworkDataStore, checkRequired } from 'src/store/preworkInfo';
import InputBox from 'src/components/atoms/input/DefInputBox';
import IconButton from 'src/components/atoms/buttons/IconButton';

interface Props {
  data: any;
  type?: string;
}
const GridList: FC<Props> = ({ type = '', data }) => {
  const preworkPayload = preworkDataStore((state: any) => state.payload);
  const bindPreworkPayload = preworkDataStore((state: any) => state.bindPayload);
  const inpStatus = type === 'list' ? '_read' : '';

  // view type
  const inpChangeEvt = (e: React.ChangeEvent<HTMLInputElement>, key: string) => {
    bindPreworkPayload({ ...preworkPayload, [key]: e.target.value });
  };
  const inpChangeNumberEvt = (e: React.ChangeEvent<HTMLInputElement>, key: string) => {
    const value: any = e.target?.value.replace(/[^0-9]/g, ''); // 숫자만 허용
    bindPreworkPayload({ ...preworkPayload, [key]: Number(value) });
  };
  const labelStyle = { width: '250px', color: '#777', fontSize: '13px' };

  return (
    <div className={['_comp_before_detail_content_div _active', inpStatus].join(' ')}>
      <div className="_row">
        <div className="_item _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeNumberEvt(e, 'name')}
            label="외국인 기술자 소득세 감면(50%)"
            labelPosition="left"
            value={addComma(preworkPayload.tred_t01 || 0)}
            required={type !== 'list' ? checkRequired('tred_t01') : ''}
            placeholder="급여를 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={{ fontSize: '15px', fontWeight: '700' }}
            status={inpStatus}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
        <div className="_item_r  _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeNumberEvt(e, 'name')}
            label="외국인 기술자 소득세 감면(70%)"
            labelPosition="left"
            value={addComma(preworkPayload.tred_t02 || 0)}
            required={type !== 'list' ? checkRequired('tred_t02') : ''}
            placeholder="급여를 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={{ fontSize: '15px', fontWeight: '700' }}
            status={inpStatus}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
      </div>
      <div className="_row">
        <div className="_item _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeNumberEvt(e, 'name')}
            // inputRef={inpRef}
            label="중소기업 취업자 소득세감면(70%)"
            labelPosition="left"
            value={addComma(preworkPayload.tred_t12 || 0)}
            required={type !== 'list' ? checkRequired('tred_t12') : ''}
            placeholder="급여를 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={{ fontSize: '15px', fontWeight: '700' }}
            status={inpStatus}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
        <div className="_item_r _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeNumberEvt(e, 'tred_t13')}
            // inputRef={inpRef}
            label="중소기업 취업자 소득세감면(90%)"
            labelPosition="left"
            value={addComma(preworkPayload.tred_t13 || 0)}
            required={type !== 'list' ? checkRequired('tred_t13') : ''}
            placeholder="급여를 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={{ fontSize: '15px', fontWeight: '700' }}
            status={inpStatus}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
      </div>
      <div className="_row">
        <div className="_item _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeNumberEvt(e, 'tred_t20')}
            // inputRef={inpRef}
            label="조세조약상 교직자 소득세감면"
            labelPosition="left"
            value={addComma(preworkPayload.tred_t20 || 0)}
            required={type !== 'list' ? checkRequired('tred_t20') : ''}
            placeholder="급여를 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={{ fontSize: '15px', fontWeight: '700' }}
            status={inpStatus}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
        <div className="_item_r _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeNumberEvt(e, 'tred_t30')}
            // inputRef={inpRef}
            label="성과공유 중소기업 경영성과급(50%)"
            labelPosition="left"
            value={addComma(preworkPayload.tred_t30 || 0)}
            required={type !== 'list' ? checkRequired('tred_t30') : ''}
            placeholder="급여를 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={{ fontSize: '15px', fontWeight: '700' }}
            status={inpStatus}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
      </div>
      <div className="_row">
        <div className="_item _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeNumberEvt(e, 'tred_t40')}
            // inputRef={inpRef}
            label="중소기업 청년·핵심인력 성과보상기금(50%)"
            labelPosition="left"
            value={addComma(preworkPayload.tred_t40 || 0)}
            required={type !== 'list' ? checkRequired('tred_t40') : ''}
            placeholder="급여를 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={{ fontSize: '15px', fontWeight: '700' }}
            status={inpStatus}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
        <div className="_item_r _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeNumberEvt(e, 'tred_t41')}
            // inputRef={inpRef}
            label="중소기업 청년·핵심인력 성과보상기금(30%)"
            labelPosition="left"
            value={addComma(preworkPayload.tred_t41 || 0)}
            required={type !== 'list' ? checkRequired('tred_t41') : ''}
            placeholder="급여를 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={{ fontSize: '15px', fontWeight: '700' }}
            status={inpStatus}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
      </div>
      <div className="_row">
        <div className="_item _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeNumberEvt(e, 'tred_t42')}
            // inputRef={inpRef}
            label="중소기업 청년·핵심인력 성과보상기금(90%)"
            labelPosition="left"
            value={addComma(preworkPayload.tred_t42 || 0)}
            required={type !== 'list' ? checkRequired('tred_t42') : ''}
            placeholder="급여를 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={{ fontSize: '15px', fontWeight: '700' }}
            status={inpStatus}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
        <div className="_item_r _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeNumberEvt(e, 'tred_t43')}
            // inputRef={inpRef}
            label="중견기업 청년·핵심인력 성과보상기금(50%)"
            labelPosition="left"
            value={addComma(preworkPayload.tred_t43 || 0)}
            required={type !== 'list' ? checkRequired('tred_t43') : ''}
            placeholder="급여를 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={{ fontSize: '15px', fontWeight: '700' }}
            status={inpStatus}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
      </div>
      <div className="_row">
        <div className="_item _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeNumberEvt(e, 'tred_t50')}
            // inputRef={inpRef}
            label="내국인 우수인력 국내복귀 소득세 감면(50%)"
            labelPosition="left"
            value={addComma(preworkPayload.tred_t50 || 0)}
            required={type !== 'list' ? checkRequired('tred_t50') : ''}
            placeholder="급여를 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={{ fontSize: '15px', fontWeight: '700' }}
            status={inpStatus}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
        <div className="_item_r _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeNumberEvt(e, 'tred_t00')}
            // inputRef={inpRef}
            label="소득세법"
            labelPosition="left"
            value={addComma(preworkPayload.tred_t00 || 0)}
            required={type !== 'list' ? checkRequired('tred_t00') : ''}
            placeholder="급여를 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={{ fontSize: '15px', fontWeight: '700' }}
            status={inpStatus}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
      </div>
    </div>
  );
};

export default GridList;
